/* eslint-disable react/no-multi-comp */
import React, { Component } from "react";
import { connect } from "react-redux";
import ReactPaginate from "react-paginate";
import moment from "moment";
import { Link } from "react-router-dom";
import { Resources } from "../redux/notificationRedux";

class NotificationList extends Component {
  constructor(props) {
    super(props);
    this.state = { forcePage: undefined, isLoading: true };
    this.perPageCount = 10;
    this.getAllNotification();
  }

  getAllNotification = () => {
    const { getTotalNotifications } = Resources;
    getTotalNotifications.url = `notifications?page=${1}&per_page=${
      this.perPageCount
    }`;
    this.props
      .Get(getTotalNotifications)
      .then(() => this.setState({ isLoading: false }));
  };

  handlePageClick = (data, moveToPrevious = false) => {
    window.scrollTo(0, 0);
    const { getTotalNotifications } = Resources;
    if (moveToPrevious) {
      getTotalNotifications.url = `notifications?page=${data.page -
        1}&per_page=${this.perPageCount}`;
      this.props.Get(getTotalNotifications).then(() => {
        this.setState({ forcePage: data.page - 2, isLoading: false });
      });
    } else {
      this.setState({ forcePage: undefined });
      const { selected } = data;
      getTotalNotifications.url = `notifications?page=${selected +
        1}&per_page=${this.perPageCount}`;
      this.props
        .Get(getTotalNotifications)
        .then(() => this.setState({ forcePage: selected, isLoading: false }));
    }
  };

  markNotificationAsRead = id => {
    const { notificationMarkAsRead } = Resources;
    notificationMarkAsRead.url = `/notifications/${id}/read`;
    this.props.Post(notificationMarkAsRead);
  };

  markAllNotificationAsRead = () => {
    const { notificationMarkAllAsRead } = Resources;
    this.props
      .Post(notificationMarkAllAsRead)
      .then(() => this.getAllNotification());
  };

  handleIcon = type => {
    if (type.search("CPU") > -1) {
      return <i className="mr-2 fas fa-microchip" />;
    }
    if (type.search("Memory") > -1) {
      return <i className="mr-2 fas fa-memory" />;
    }
    if (type.search("Disk") > -1) {
      return <i className="mr-2 fas fa-compact-disc" />;
    }
    if (type === "Temperature") {
      return <i className="mr-2 fas fa-thermometer-half" />;
    }
  };

  render() {
    const { isLoading } = this.state;
    if (isLoading) {
      return (
        <div className="d-block text-center">
          <svg className="spinner" viewBox="0 0 50 50">
            <circle
              className="path"
              cx="25"
              cy="25"
              r="20"
              fill="none"
              strokeWidth="4"
            />
          </svg>{" "}
        </div>
      );
    }
    return (
      <div className="mainPage">
        <div className="contentSection">
          {this.props.notifications.length > 0 ? (
            <div>
              <div className="notificationContainer">
                <div className="d-flex">
                  <span
                    className="mt-3 mr-4 ticket-notification_mark-all-as-read ml-auto"
                    onClick={this.markAllNotificationAsRead}
                  >
                    Mark all as read
                  </span>
                </div>
                <ul>
                  {" "}
                  {this.props.notifications.map(item => (
                    <Link
                      to={{
                        pathname: `/networks/device/${item.attributes.device_id}?id=${item.attributes.device_group_id}&gn=${item.attributes.device_group_name}&n=${item.attributes.device_name}&view=groups`,
                        state: {
                          key: item.id,
                          deviceID: item.attributes.device_id,
                          groupID: item.attributes.device_group_id,
                          groupName: item.attributes.device_group_name,
                          name: item.attributes.device_name || "",
                          fromNotification: true
                        }
                      }}
                    >
                      <li
                        key={item.id}
                        style={{
                          background:
                            !item.attributes.read && "rgb(234, 248, 241)"
                        }}
                        onClick={() => {
                          this.markNotificationAsRead(item.id);
                        }}
                      >
                        <div className="d-flex">
                          <div className="mr-auto">
                            <strong>{item.attributes.hostname} </strong> has
                            exceeded{" "}
                            <strong> {item.attributes.alert_type} </strong>{" "}
                            threshold.{" "}
                          </div>
                          <div
                            style={{
                              color: "darkgrey",
                              fontSize: "12px",
                              marginTop: "2px"
                            }}
                          >
                            {moment.utc(item.attributes.created_at).fromNow()}
                          </div>
                        </div>
                        <div className="mt-2 mb-2">
                          {this.handleIcon(item.attributes.alert_type)}
                          {item.attributes.value}%
                          <i className="mr-2 ml-3 fas fa-desktop" />
                          {item.attributes.mac_address}
                        </div>
                      </li>
                    </Link>
                  ))}
                </ul>
              </div>
              <div className="contentSectionPagination notificationPagination">
                <ReactPaginate
                  pageCount={this.props.meta ? this.props.meta.totalPages : 0}
                  pageRangeDisplayed={3}
                  onPageChange={this.handlePageClick}
                  marginPagesDisplayed={2}
                  containerClassName="pagination flex-wrap"
                  subContainerClassName="pages pagination"
                  activeClassName="active"
                  previousLinkClassName="pagination-label
                  "
                  nextLinkClassName="pagination-label"
                  previousLabel="<"
                  forcePage={this.state.forcePage}
                  nextLabel=">"
                  breakLabel="..."
                  breakClassName="break-me"
                  disabledClassName="paginationDisable"
                />
              </div>
            </div>
          ) : (
            <div id="notfound">
              <div className="notfound">
                <div className="notfound-404">
                  <i className="fas fa-bell fa-4x" />

                  <h3 className="mt-3"> No notifications right now!</h3>
                </div>
                <Link to="/dashboard">
                  Go to Homepage
                  <i className="fa fa-arrow-right" />
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    notifications: state.totalNotificationList.list || [],
    meta: state.totalNotificationList.meta || {}
  };
}

export default connect(
  mapStateToProps,
  {}
)(NotificationList);
